import Vue from 'vue'
import VueI18n from 'vue-i18n'
import DirectiveHtmlClass from '@/helpers/DirectiveHtmlClass'
import { config, readFromComponentOptions, readFromHtmlJson } from '@/config'
import dayjs from '@/helpers/dayjs'

let initializedOnce = false

// plugins
Vue.use(VueI18n)
Vue.use(DirectiveHtmlClass)
Vue.mixin({
    methods: {
    }
})

let i18n = null

export default function (dom, opts) {
  const options = {
    ...opts
  }

  readFromHtmlJson()
  readFromComponentOptions(options)

  // we try to initialize as late as possible
  if (!initializedOnce) {
    dayjs.locale(config.LANGUAGE)

    i18n = new VueI18n({
      locale: config.LANGUAGE
    })

    initializedOnce = true
  }

  // component specific translation
  if (options.i18n) {
    Object.entries(options.i18n)
      .forEach(([k, v]) => {
        i18n.mergeLocaleMessage(k, v)
      })
  }

  const page = new Vue({
    el: dom,
    i18n,
    data: {
      shared: options.sharedData,
      options
    },
    render (h, context) {
      return h(options.vueComponent, {})
    },
    created () {
      if (options.vueInit) {
       console.info("da");
      }
    }
  })
  return page
}
